import request from '@/utils/request'

/**
 * 销售概览指标（6 个 KPI 卡片，最新月份）
 * @returns {Promise}
 */
export function getSalesOverview() {
  return request({
    url: '/eiip-ai/sales/overview',
    method: 'get'
  })
}

/**
 * 销售业务阶段概览
 * @returns {Promise}
 */
export function getSalesStageOverview() {
  return request({
    url: '/eiip-ai/sales/stage-overview',
    method: 'get'
  })
}

/**
 * 今天需要处理的待办
 * @returns {Promise}
 */
export function getSalesTodayTasks() {
  return request({
    url: '/eiip-ai/sales/today-tasks',
    method: 'get'
  })
}

/**
 * 近 6 个月签约与回款趋势
 * @returns {Promise}
 */
export function getSalesSignPaymentTrend() {
  return request({
    url: '/eiip-ai/sales/sign-payment-trend',
    method: 'get'
  })
}

/**
 * 商机报价首页聚合数据（待办 + 报价项目清单 + 预警规则）
 * @returns {Promise}
 */
export function getQuoteOpportunityHome() {
  return request({
    url: '/eiip-ai/sales/quote-opportunity',
    method: 'get'
  })
}

/**
 * 客户洞察首页聚合数据（重点客户分层 + 经营漏斗 + 商机推进 + 经营风险）
 * @returns {Promise}
 */
export function getCustomerInsightHome() {
  return request({
    url: '/eiip-ai/sales/customer-insight',
    method: 'get'
  })
}
